import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import StandartPage from '../../Layouts/Shared/_StandartPage';
import CompDtOrders from '../../Components/MarketPlaceManagement/CompDtOrders';

export default function Orders() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [seed, setSeed] = useState(0);
    const [data, setData] = useState(null);

    return (
        <StandartPage title={t('pages.market-place-management-orders.title')} >
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="col-12 p-2 container">
                        <CompDtOrders />
                    </Col>
                </Row>
            </React.Fragment>
        </StandartPage>
    )

}